module.exports = __webpack_public_path__ + "media/images/top_menu_icon/disclaimers-b83ba30a03a21d98dcd0051d8dc13437.png";